'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _executivesummary = require('./executivesummary.html');

var _executivesummary2 = _interopRequireDefault(_executivesummary);

var _executivesummary3 = require('./executivesummary.controller');

var _executivesummary4 = _interopRequireDefault(_executivesummary3);

require('./executivesummary.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var executivesummaryComponent = {
  restrict: 'E',
  bindings: {},
  template: _executivesummary2.default,
  controller: _executivesummary4.default,
  controllerAs: 'vm'
};

exports.default = executivesummaryComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary/executivesummary.component.js